<ion-searchbar [placeholder]="filterModel.placeHolder" [debounce]="1000" (ionChange)="handleChange($event)">
</ion-searchbar>
